import React from 'react';

interface Option {
  value: string;
  label: string;
  shortLabel?: string;
  valueLabel?: string;
}

interface HorizontalSelectorProps {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  colorScheme?: 'default' | 'risk' | 'performance';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const HorizontalSelector: React.FC<HorizontalSelectorProps> = ({
  options,
  value,
  onChange,
  size = 'sm',
  className = ''
}) => {
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-sm'
  };

  const hasValueLabels = options.some(option => option.valueLabel);

  return (
    <div className={className}>
      {hasValueLabels && (
        <div className="flex mb-1">
          {options.map((option) => (
            <div key={`${option.value}-label`} className="flex-1 text-center">
              <span className="text-xs text-gray-400">
                {option.valueLabel || ''}
              </span>
            </div>
          ))}
        </div>
      )}

      <div className="inline-flex border border-gray-300 w-full">
        {options.map((option, index) => {
          const isSelected = value === option.value;

          return (
            <button
              key={option.value}
              onClick={() => onChange(option.value)}
              className={`
                ${sizeClasses[size]}
                ${isSelected ? 'bg-gray-900 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}
                ${index > 0 ? 'border-l border-gray-300' : ''}
                min-w-0 flex-1 text-center
              `}
              type="button"
            >
              <span className="truncate">
                {option.shortLabel || option.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
